module.exports = __webpack_public_path__ + "img/battle_tower.4550a6a4.jpg";